module.exports = __webpack_public_path__ + "static/img/laptop-1.d3d1e93.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/laptop-1.svg
// module id = iTzw
// module chunks = 1